import { externalLinkRedirect } from '@/router';
import { client } from '../http';

async function fetchAgamResults() {
  const response = await client.get('/api/agam');
  return response.data;
}

async function downloadAgamReport() {
  externalLinkRedirect('/api/download-agam-report');
}

export default {
  fetchAgamResults,
  downloadAgamReport,
};
